import { render, staticRenderFns } from "./ManualGradingExamPage.vue?vue&type=template&id=2fe9e10a"
import script from "./ManualGradingExamPage.vue?vue&type=script&lang=js"
export * from "./ManualGradingExamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports